import React from "react";
import { motion } from "framer-motion";
import { Phone, MessageCircle, Check } from "lucide-react";

const WebsitePricing = () => {
  const phoneNumber = "918700661267";
  
  const handleCall = () => {
    window.location.href = `tel:+${phoneNumber}`;
  };

  const handleWhatsApp = () => {
    window.open(`https://wa.me/${phoneNumber}`, '_blank');
  };

  const pricingPlans = [
    {
      title: "Business Information Website",
      price: "₹15,000",
      color: "bg-blue-500",
      hoverColor: "hover:bg-blue-600"
    },
    {
      title: "Ecommerce Website on React",
      price: "₹25,000",
      color: "bg-green-500",
      hoverColor: "hover:bg-green-600"
    },
    {
      title: "Convert Website into Android App",
      price: "₹5,000",
      color: "bg-purple-500",
      hoverColor: "hover:bg-purple-600"
    }
  ];

  const inclusions = [
    "1 Year Domain",
    "5GB Cloud Hosting",
    "Two Professional Emails",
    "3 Months Support"
  ];

  return (
    <section className="bg-gradient-to-br from-blue-50 to-purple-50 py-12 md:py-16 px-4 md:px-6 mt-36">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
          viewport={{ once: true }}
          className="text-center mb-8 md:mb-12"
        >
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-3 md:mb-4">
            Affordable Website Development Packages
          </h2>
          <p className="text-base md:text-lg text-gray-600">
            Choose the perfect plan for your business needs
          </p>
        </motion.div>

        {/* Pricing Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 mb-8 md:mb-10">
          {pricingPlans.map((plan, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: index * 0.05 }}
              viewport={{ once: true }}
              className="bg-white rounded-xl shadow-lg p-5 md:p-6 text-center transform hover:scale-105 transition-transform duration-300"
            >
              <div className={`${plan.color} text-white rounded-lg py-3 md:py-4 px-3 md:px-4 mb-4`}>
                <h3 className="text-xl md:text-2xl font-semibold mb-2 leading-tight">
                  {plan.title}
                </h3>
                <p className="text-3xl md:text-4xl font-bold">{plan.price}</p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Inclusions */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, delay: 0.1 }}
          viewport={{ once: true }}
          className="bg-white rounded-xl shadow-lg p-5 md:p-8 mb-6 md:mb-8"
        >
          <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 md:mb-6 text-center">
            All Plans Include:
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4 max-w-3xl mx-auto">
            {inclusions.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.2, delay: 0.15 + index * 0.05 }}
                viewport={{ once: true }}
                className="flex items-center gap-3 bg-green-50 rounded-lg p-3 md:p-4"
              >
                <Check size={24} className="text-green-600 flex-shrink-0" />
                <span className="text-base md:text-lg text-gray-700 font-medium">{item}</span>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* Call to Action Buttons */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, delay: 0.2 }}
          viewport={{ once: true }}
          className="flex flex-col sm:flex-row gap-4 justify-center items-center"
        >
          <button
            onClick={handleCall}
            className="w-full sm:w-auto flex items-center justify-center gap-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold px-6 md:px-8 py-3 md:py-4 rounded-full shadow-lg transition-all duration-300 transform hover:scale-105 text-base md:text-lg"
          >
            <Phone size={24} />
            Call Now: +91 8700661267
          </button>
          <button
            onClick={handleWhatsApp}
            className="w-full sm:w-auto flex items-center justify-center gap-3 bg-green-600 hover:bg-green-700 text-white font-semibold px-6 md:px-8 py-3 md:py-4 rounded-full shadow-lg transition-all duration-300 transform hover:scale-105 text-base md:text-lg"
          >
            <MessageCircle size={24} />
            WhatsApp Us
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default WebsitePricing;
